export default __webpack_public_path__ + "static/media/fruit-480w.4829a2b2.webp";